import React, {Component} from 'react';
import {connect} from 'react-redux';
import webp from '../../utils/webp';
import { observer, inject } from "mobx-react";

class LazyBlock extends Component {
  constructor(props) {
    super(props);
    this.state={
      visible: false
    }
  }
  componentDidMount() {
    if("IntersectionObserver" in window) {
      this.observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            const {isIntersecting} = entry;
            if (isIntersecting) {
              if(this.element) {
                this.setState({ visible:true });
              }
              this.observer = this.observer.disconnect();
            }
          });
        },
        {
          //root: document.querySelector(".container"),
          rootMargin: "0px 0px 0px 0px"
        }
      );
      this.observer.observe(this.element);
    } else {
      this.setState({ visible:true });
    }
  }
  renderInner() {
    if(/*false && */this.state.visible) {
      return this.props.children;
    } else {
      if(this.props.placeHolder) {
        return this.props.placeHolder();
      }
      return null;
    }
  }
  render() {
    if(this.props.disabled) {
      return this.props.children;
    }
    return (
      <div ref={el => this.element = el}>
        {this.renderInner()}
      </div>
    )
  }
}


export default observer(LazyBlock);